import { makeStyles, Tooltip } from "@material-ui/core";
import { useTopics } from "../../store/TopicsState";

const useStyles = makeStyles(() => ({
	pickup: {
		width: 40,
		height: 40,
		padding: '1px 0',
		borderRadius: 10,
		backgroundColor: 'white',
		boxSizing: 'border-box',
		boxShadow: '0 1px 2px rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%)',
		cursor: 'pointer',
		overflow: 'hidden',
	},
}));

function Anchor({href, target, children}) {
	if (href) {
		return (
			<a href={href} target={target}>
				{children}
			</a>
		);
	} else {
		return children;
	}
}

function Topics({type, tooltipPlacement, ...prop}) {
	const {topics, fixURL} = useTopics(type || 'season1');

	const classes = useStyles();

	return (
		<>
			{topics &&
				<div {...prop} className={classes.pickup}>
					<Anchor href={fixURL(topics.link)} target="_blank">
						<Tooltip placement={tooltipPlacement || "right-end"} title={topics.text}>
							<img src={fixURL(topics.image)} alt={"Topics"} style={{ maxWidth: 38, maxHeight: 38, verticalAlign: 'middle' }} />
						</Tooltip>
					</Anchor>
				</div>
			}
		</>
	);
};

export default Topics;
